import ApiService from './api';
import { useAuthStore } from '@/stores/auth';

/** Payload describing a frontend error reported to the backend log. */
export interface FrontendErrorData {
  /** The URL where the error occurred. */
  url: string;
  /** The timestamp of the error. */
  timestamp: string;
  /** The error object (serialized message/stack). */
  error: any;
  /** The user agent string of the browser. */
  userAgent: string;
}

const ErrorLogService = {
  /**
   * Logs a frontend error to the server.
   *
   * @param errorData - The error data to log.
   * @returns Promise resolving to the response data or error object.
   */
  async sendErrorToServer({ url, timestamp, error, userAgent }: FrontendErrorData): Promise<any> {
    const authStore = useAuthStore();
    const username = authStore.userGetter?.username || 'unknown';
    const botId = authStore.lastUsedBotId || 'unknown';
    const data = {
      botId,
      username,
      url,
      timestamp,
      error,
      userAgent,
    };
    try {
      const response = await ApiService.post('/schaltzentrale/frontend-errors', data);
      return response.data;
    } catch (error) {
      return { error };
    }
  },

  /**
   * Posts a message to the developers' notification channel (Slack).
   * @param message - The message to send.
   * @returns Promise resolving to the response data or error object.
   */
  async sendDevNotification(message: string): Promise<any> {
    try {
      const response = await ApiService.post('/schaltzentrale/system-notification/dev', { message });
      return response.data;
    } catch (error) {
      return { error };
    }
  },
};

export default ErrorLogService;
